import axios from "axios";
import { alertBridge } from "../context/alert-context";
import config from "../config";

axios.defaults.withCredentials = true;

const API = axios.create({ baseURL: `${config.api.baseUrl}` });

// Gestion du token CSRF
let csrfToken = null;

export async function fetchCsrfToken() {
  try {
    const res = await API.get("/csrf-token");
    csrfToken = res.data.csrfToken;
  } catch (err) {
    // Optionnel : afficher une erreur si besoin
  }
}

API.interceptors.request.use(
  async (config) => {
    // Ajoute le header CSRF sur les requêtes d'écriture
    if (["post", "put", "patch", "delete"].includes(config.method)) {
      if (!csrfToken) {
        await fetchCsrfToken();
      }
      if (csrfToken) {
        config.headers["x-csrf-token"] = csrfToken;
      }
    }
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => {
    if (!response.config?.silent && response.data && response.data.message) {
      alertBridge.showAlert?.("success", response.data.message);
    }
    return response;
  },
  async (error) => {
    if (!error.config?.silent && error.response && error.response.data) {
      if (error.response.data.message) {
        alertBridge.showAlert?.("error", error.response.data.message);
      } else if (Array.isArray(error.response.data.errors)) {
        const messages = error.response.data.errors.map((e) => e.message).join(" — ");
        alertBridge.showAlert?.("error", messages);
      }
    }
    return Promise.reject(error);
  }
);

export default API;
